var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExpertiseMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 104,
    viewBox: "0 0 344 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_28804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1216 102C1216 102 247.583 102 146.325 102H107.937M0 102H23.6316C23.8351 102 24 101.835 24 101.632V101.632C24 96.2894 28.3873 91.8683 33.6886 91.8683H90.906C96.2073 91.8683 100.595 96.2894 100.595 101.632V102H36.4097M91.0892 91.5009V91.8694H33.3234V91.5009C33.3234 86.1588 37.7106 81.7377 43.0119 81.7377H81.2178C86.7019 81.7377 91.0892 86.1588 91.0892 91.5009ZM140.629 92.4219C138.618 94.4482 135.51 94.4482 133.682 92.4219L91.6377 50.0531L98.5842 43.053L140.629 85.4218C142.457 87.264 142.457 90.3956 140.629 92.4219ZM89.082 11.4578L109.505 32.0383L80.6801 61.0855L60.257 40.5049L89.082 11.4578ZM74.0885 67.3692C75.5509 68.8429 77.9274 68.8429 79.5726 67.3692L83.4115 63.5008L57.819 38.0795L53.9801 41.9479C52.5177 43.4216 52.5177 45.8164 53.9801 47.4743L74.0885 67.3692ZM115.767 25.3686C117.23 26.8423 117.23 29.2371 115.767 30.895L111.928 34.7634L86.7015 8.97373L90.5404 5.10527C92.0028 3.63158 94.3793 3.63158 96.0245 5.10527L115.767 25.3686Z",
    stroke: "#00B4AA",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_28804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 344,
    height: 104,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpertiseMobile);
export default __webpack_public_path__ + "static/media/icon-expertise-mobile.6c34ee9f.svg";
export { ForwardRef as ReactComponent };